class OettingerCartPageTerms extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('[data-oettinger-cart-page-terms-checkbox]');
    this.footer = this.closest('#main-cart-footer');
    this.checkoutButton = document.querySelector('[data-oettinger-cart-page-checkout]');
    this.updateCheckoutState = this.updateCheckoutState.bind(this);
  }

  connectedCallback() {
    if (!this.checkbox || !this.checkoutButton) return;
    this.checkbox.addEventListener('change', this.updateCheckoutState);
    this.updateCheckoutState();
  }

  disconnectedCallback() {
    if (!this.checkbox) return;
    this.checkbox.removeEventListener('change', this.updateCheckoutState);
  }

  updateCheckoutState() {
    if (!this.checkoutButton) return;
    const isAccepted = this.checkbox.checked;
    this.checkoutButton.disabled = !isAccepted;
    this.footer?.classList.toggle('oettinger-cart-page--terms-accepted', isAccepted);
    window.oettingerShippingGuard?.validate();
  }
}

if (!customElements.get('oettinger-cart-page-terms')) {
  customElements.define('oettinger-cart-page-terms', OettingerCartPageTerms);
}
